module.exports = __webpack_public_path__ + "img/box-5.f774f923.png";